export default {
  DARK: {
    paragraph: p => p.accentWhite,
    socialColor: p => p.accentWhite,
    background: p => p.tertiaryDark
  },
  LIGHT: {
    paragraph: p => p.tertiaryDark,
    socialColor: p => p.tertiaryDark,
    background: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    paragraph: p => p.tertiaryDark,
    socialColor: p => p.tertiaryDark,
    background: p => p.tertiaryExtraLight
  }
}
